/** Migrates legacy recibo_simples field names when loading saved documents. */
export function normalizeReciboSimplesLoadedFormData(data) {
  if (!data || typeof data !== "object") return data;

  const next = { ...data };
  if (next.NOME_PESSOA_FISICA == null && next.NOME_PAGADOR != null) {
    next.NOME_PESSOA_FISICA = next.NOME_PAGADOR;
  }
  delete next.NOME_PAGADOR;
  return next;
}
